import React from "react";
import circle from "../../images/circle-shape.png";
import author from "../../images/author-03.jpg";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape14 from "../../images/shape-14.png";
import logo from "../../images/logo.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import cardiology from "../../images/Cardiology.jpg";
import Accordion from "react-bootstrap/Accordion";

const CourseLec = () => {
  const [courseSub, setcourseSub] = useState([]);
  const [courseTitle, setcourseTitle] = useState([]);
  const [showLessons, setshowLessons] = useState([]);
  const [lessonSub, setlessonSub] = useState([]);
  const [subjectData, setsubjectData] = useState([]);

  const [lessImage, setlessImage] = useState([]);
  const [omarImage, setOmarImage] = useState({ image: "" });

  let { id } = useParams();
  const navigate = useNavigate();
  function Nav(s) {
    navigate("/courseLesson/" + s);
  }
  function EachLesson(s, o) {
    document.documentElement.requestFullscreen();
    navigate("/courseList/" + s + "/" + o);
  }
  async function getlessonSub() {
    let { data } = await axios.get(
      `https://maps-medics-be.onrender.com/show_subjects/${id}`
    );
    console.log(data);
    setsubjectData(data)
    setlessonSub(data.result[0].lessons);
    console.log(data.result[0].lessons);

    // setcourseTitle(data);
    setlessImage(data.result[0]);
    setOmarImage({ image: sessionStorage.getItem("course_image") });
    console.log(lessImage.image);
  }
  async function getcourseSub() {
    let { data } = await axios.get(
      `https://maps-medics-be.onrender.com/show_subjects/${id}`
    );
    setcourseSub(data.result);
    setcourseTitle(data);

    console.log(data.result);
  }
  async function getshowLessons() {
    let { data } = await axios.get(
      "https://maps-medics-be.onrender.com/show_lessions/" +
        id +
        "/" +
        sessionStorage.getItem("user_id")
    );
    setshowLessons(data.result);

    console.log(data.result);
  }

  // let currentIndex = 0;
  // console.log(lightContainer);
  useEffect(() => {
    console.log(document.getElementById("demo").offsetHeight, "Salah");
    getcourseSub();
    getshowLessons();
    getlessonSub();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    const formattedDuration = [];
    if (hours > 0) {
      formattedDuration.push(`${hours}h`);
    }
    if (minutes > 0) {
      formattedDuration.push(`${minutes}m`);
    }
    if (seconds > 0) {
      formattedDuration.push(`${seconds}s`);
    }

    return formattedDuration.join(" ");
  };
  const date = new Date(subjectData.last_update);
  const formattedDate = date.toLocaleDateString();
  return (
    <>
      {/* <Navbar/> */}
      {/* <div class="section page-banner">

      <div style={{backgroundColor:'rgba(0,0,0,0.4)', width:'100%', height:'100%',display:'flex', justifyContent:'center', alignItems:'center'}}>

<div class="container" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
    <div class="page-banner-content">
      
        <h2 class="title"  style={{color:'#fff'}}>Our  <span>Course.</span></h2>
    </div>
</div>

</div>

</div> */}
      {/* <div className="section">
  <div className="cover" style={{backgroundColor:'#FFCF29'}}>
<div className="coverComp">

</div>
<div className="coverFilter">
  
</div>
<div className="courseHeader" style={{position:'relative'}}>
<div className="courseNav">
  <div className="container">
    <div className="row" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
      <nav className="col-md-8">
        <ol>
          <li>Courses /</li>
          <li>Cardiology</li>

        </ol>
      </nav>

    </div>
  </div>
</div>
</div>
  </div>
</div> */}

      <div
        className="section sectionTopic"
        style={{
          paddingBottom: "0px",
          marginTop:
            document.getElementById("demo") &&
            document.getElementById("demo").offsetHeight + "px",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffc600",
            opacity: "0.1",
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "0",
            left: "0",
            backgroundSize: "cover",
          }}
        >
          {" "}
        </div>
        <div className="container" style={{ position: "relative" }}>
          <div className="row" style={{ paddingTop: "4%" }}>
            <div className="col-md-3">
              <img
                src={omarImage.image}
                alt=""
                style={{ border: "1px solid #68465f", zIndex: "99" }}
              />
            </div>
            <div className="col-md-9">
              <h1
                style={{
                  fontWeight: "700",
                  color: "#fff",
                  lineHeight: "1.2em",
                  fontFamily: "Playfair Display",
                }}
              >
                {courseTitle.name}
              </h1>
              <p
                style={{
                  fontSize: "20px",
                  fontFamily: "Poppins",
                  fontWeight: "500",
                }}
              >
                {courseTitle.description}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="section " style={{ paddingBottom: "4%" }}>
        <div class="container">
          <div class="row ">
            <div className="col-md-3">
              <div className="courseSidebar">
                {/* <div style={{ display: "flex", justifyContent: "center" }}>
                  <button className="btn Join">
                    {" "}
                    <Link style={{ textDecoration: "none", color: "#000" , cursor:'default'}}>
                      {" "}
                      Join This Course
                    </Link>
                  </button>
                </div> */}
                <div
                  className="sidebarCollapse"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "5%",
                  }}
                >
                  <table>
                    <tbody>
                      <tr
                        style={{
                          borderBottom: "1px solid #cccccc",
                          borderSpacing: "2px",
                        }}
                      >
                        <th style={{ paddingLeft: "8px" }}>Responsible</th>
                        <td><span>{subjectData.instructor}</span></td>
                      </tr>

                      <tr style={{ borderBottom: "1px solid #cccccc" }}>
                        <th style={{ paddingLeft: "8px" }}>Last Update</th>
                        <td><span>{formattedDate}</span></td>
                      </tr>

                      <tr style={{ borderBottom: "1px solid #cccccc" }}>
                        <th style={{ paddingLeft: "8px" }}>Duration</th>
                        <td><span> {formatDuration(subjectData.duration)}</span></td>
                      </tr>

                      {/* <tr style={{borderBottom:'1px solid #cccccc'}}><th>Members</th>
  <td><span>1</span></td></tr> */}
                    </tbody>
                  </table>
                </div>
                {/* <div className="mt-3 d-grid">
                  <button className="btnLink">
                    <i
                      class="fa-solid fa-share-nodes"
                      style={{ color: "#b38b00", marginRight: "2px" }}
                    ></i>
                    Share
                  </button>
                </div> */}
              </div>
            </div>
            <div className="col-md-9">
              {courseSub.map((p, index) => (
                <>
                  <Accordion
                    value={p.id}
                    key={index}
                    style={{ marginTop: "4%" }}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header
                        onClick={() => {
                          console.log(omarImage);
                          setOmarImage(p);
                        }}
                      >
                        <i
                          class="fa-brands fa-youtube"
                          style={{ marginRight: "2px" }}
                        ></i>{" "}
                        {p.name}
                      </Accordion.Header>
                      {lessonSub.map((o, index) => (
                        <Accordion.Body key={index}>
                          <span
                            onClick={() => EachLesson(p.id, o.real_id)}
                            style={{
                              color: "#000",
                              cursor: "pointer",
                              fontFamily: "Poppins",
                              fontSize: "16px",
                            }}
                          >
                            {" "}
                            {o.name}
                          </span>
                        </Accordion.Body>
                      ))}
                    </Accordion.Item>
                  </Accordion>

                  {/* <div className=" p-3" value={p.id} key={index}>
<div className='p-3' style={{width:'100%' , border:'1px solid #dee2e6',marginTop:'8px'}}>
<div >
<h3  style={{textDecoration:'none', cursor:'pointer', fontSize:'16px', fontFamily:'Poppins'}} onClick={()=>Nav(p.id)}><i class="fa-brands fa-youtube" style={{ marginRight:'2px'}}></i> {p.name}</h3>
</div>
</div>
</div> */}
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default CourseLec;
